// extracted by mini-css-extract-plugin
export default {"wrapper":"welcomeSite_wrapper__UPvJS"};